const Consolidated = ({children}) => {
    return (  
        <div>
            
            {children}
        
        </div>
    );
}
 
export default Consolidated;